<div class="header_search">
  <div class="title-page">
    <h3>Dados do processo</h3>
  </div>
</div>

<form [formGroup]="form">
  <div class="form-group row m-b">
    <div class="col-xxl-8 col-lg-10 col-sm-12">
      <label class="col-sm-12 pb-1">Resp. Análise Processo</label>
      <ng-select id="process_analyst" class="ng-select-alternative" [items]="entity?.processAnalystList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="process_analyst"></ng-select>
      <app-field-message [field]="fieldMessageRequired('process_analyst')" [erros]="fieldErros('process_analyst')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-xxl-8 col-lg-10 col-sm-12">
      <label class="col-sm-12 pb-1">Status do processo</label>
      <ng-select id="process_stat_id" class="ng-select-alternative" [items]="entity?.processStatIdList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="process_stat_id" [clearable]="false"></ng-select>
      <app-field-message [field]="fieldMessageRequired('process_stat_id')" [erros]="fieldErros('process_stat_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-xxl-8 col-lg-10 col-sm-12">
      <label class="col-sm-12 pb-1">Data conclusão processo</label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="process_dt_conclusion" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (keyup)="clearInput($event)">
      <app-field-message [field]="fieldMessageRequired('process_dt_conclusion')" [erros]="fieldErros('process_dt_conclusion')"></app-field-message>
    </div>
  </div>


  <div class="form-group row m-b">
    <div class="col-xxl-8 col-lg-10 col-sm-12">
      <label class="col-sm-12 pb-1">Projeto Selecionado</label>
      <ng-select id="project_selected" class="ng-select-alternative" [items]="entity?.projectSelected" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="project_selected" [clearable]="false"></ng-select>
      <app-field-message [field]="fieldMessageRequired('project_selected')" [erros]="fieldErros('project_selected')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-xxl-8 col-lg-10 col-sm-12">
      <label class="col-sm-12 pb-1">Status do projeto</label>
      <input class="form-control" formControlName="process_sub_stat_name">
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-xxl-8 col-lg-10 col-sm-12">
      <label class="col-sm-12 pb-1">Posição</label>
      <input class="form-control" formControlName="process_control_name">
    </div>
  </div>
</form>

<div class="header_search m-t-xl">
  <div class="title-page">
    <h3>Mensagens</h3>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Mensagem</th>
          <th>Anexos</th>
          <th class="text-center">Enviado em</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of entity?.messageList">
          <tr>
            <td class="title"><span class="title-span">{{item?.description}}</span></td>
            <td>
              <div *ngFor="let doc of item?.doc">
                <p (click)="download(doc)" class="download">{{ doc?.name }}</p>
              </div>
            </td>
            <td class="text-center">{{ item?.user_name }}
              <div>{{ item?.ctr_dth_inc }}</div>
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="!entity?.messageList?.length" class="border-b-radius">
          <td colspan="3" class="text-center">Nenhum Mensagem Enviada.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="entity?.id && entity?.can_delete" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-white m-r-xs" *ngIf="entity?.id" type="button" (click)="imprimir()">Imprimir</button>
      <button class="btn btn-white m-r-xs" *ngIf="entity?.id && entity?.can_clone" type="button" (click)="openCloneModal()">Clonar</button>
      <button class="btn btn-primary m-r-xs" *ngIf="entity?.can_save" (click)="update(true)">Salvar</button>
      <button class="btn btn-primary" *ngIf="entity?.can_save && entity?.process_control_id == entity?.typeAvaliador?.TYPE_CONTROL_ORGAO" (click)="openModal(2)">Salvar e Transferir para avaliador</button>
      <button class="btn btn-primary" *ngIf="entity?.can_save && entity?.process_control_id == entity?.typeAvaliador?.TYPE_CONTROL_AVALIADOR" (click)="openModal(3)">Salvar e Transferir para avaliado</button>
    </div>
  </div>
</div>

<app-historico-atualizacoes-list *ngIf="entity?.id" [audit]="audit"></app-historico-atualizacoes-list>


<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Transferência</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row m-b">
      <div class="col-xxl-8 col-lg-10 col-sm-12">
        <label class="col-sm-12 pb-1">Mensagem</label>
        <textarea id="routing_description" class="form-control" [(ngModel)]="routing.routing_description" rows="4" maxlength="4000"></textarea>
      </div>
    </div>

    <div *ngFor="let file of files; let i = index" class="form-group row m-b">
      <div class="col-10 col-md-8 col-xl-6">
        <label class="col-sm-12 pb-1">Arquivo <span *ngIf="files?.length > 1">{{ i + 1 }}</span></label>
        <input type="file" class="form-control" (change)="onFileSelected($event, i)" />
      </div>
      <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="files?.length > 1 && i != 0" (click)="removeFileField(i)">
        <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
      </button>
    </div>

    <button class="btn btn-success btn-add-item mb-4" type="button" (click)="addFileField()">Novo Arquivo</button>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeModal()">Fechar</button>
        <button class="btn btn-primary" type="button" (click)="update()">Salvar</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalClone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar processo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Novo Nome</label>
        <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>